// import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DrChayyaPalancontent = () => {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: "#fff9ee", padding: "40px 20px", paddingTop: "120px" }}>

             <div
                className="doctor-intro-container"
                style={{
                  maxWidth: "1100px",
                  margin: "auto",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "32px",
                  textAlign: "left",
                }}
              >

               <img
                 src="/Doctorprofile.png"
                 alt="Dr. Aaradhya Sharma"
                 style={{
                   width: "220px",
                   height: "220px",
                   borderRadius: "50%",
                   objectFit: "cover",
                   border: "3px solid #ddd",
                   flexShrink: 0,
                 }}
               />
           
               <div
                 className="vertical-divider"
                 style={{
                   width: "2px",
                   backgroundColor: "#ccc",
                   height: "100%",
                   minHeight: "160px",
                   display: "none",
                 }}
               ></div>
           
               <div
                 style={{
                   display: "flex",
                   flexDirection: "column",
                   gap: "16px",
                   flex: 1,
                   minWidth: "260px",
                 }}
               >
                 <div
                   style={{
                     display: "flex",
                     flexDirection: "column",
                     gap: "16px",
                   }}
                   className="content-container"
                 >
                   <div
                     style={{
                       display: "flex",
                       flexDirection: "column",
                       gap: "16px",
                     }}
                     className="inner-content"
                   >
                     
                     <div style={{ flex: 1 }}>
                       <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                         Dr. Chayya Palan
                       </h2>
                       <p style={{ margin: "4px 0", color: "#333" }}>
                         <strong>Specialization:</strong> Your Partner in Mind-Body Wellness
                       </p>
                       <p style={{ margin: "4px 0", color: "#333" }}>
                         <strong>Experience:</strong> 11 Years specializing in Maternal Psychology
                       </p>
                       <p style={{ margin: "4px 0", color: "#333" }}>
                         <strong>Degrees:</strong> MSc (Clinical Psychology), Advance Diploma in Counselling Psychology.
                       </p>
                     </div>
                       <div
                         className="vertical-divider"
                         style={{
                           width: "2px",
                           backgroundColor: "#ccc",
                           height: "100%",
                           minHeight: "160px",
                           display: "none",
                         }}
                       ></div>
                     
                     <div style={{ flex: 1 }}>
                       <p
                         style={{
                           fontStyle: "italic",
                           fontSize: "15px",
                           lineHeight: "1.6",
                           color: "#444",
                           marginTop: "4px",
                         }}
                       >
                         "A healthy baby starts with a happy, peaceful mother. We will care for your mind
                          and spirit with the same dedication we give to your physical health."
                       </p>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>

              <style>
                  {`
                    @media (min-width: 768px) {
                      .vertical-divider {
                        display: block !important;
                      }
                
                      .inner-content {
                        flex-direction: row !important;
                      }
                    }
                
                    @media (max-width: 767px) {
                      .doctor-intro-container {
                        flex-direction: column;
                        align-items: center !important;
                        text-align: center !important;
                      }
                
                      .inner-content {
                        flex-direction: column !important;
                        align-items: center !important;
                        text-align: center !important;
                      }
                
                      .content-container {
                        align-items: center !important;
                        text-align: center !important;
                      }
                    }
                  `}
                </style>

   
         <div style={{ padding: "40px 20px", maxWidth: "1100px", margin: "auto" }}>
           <h3>My Philosophy on Pregnancy Care:</h3>
           <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
             I practice with a holistic view. Pregnancy isn't just about
             scans and tests; it's about your sleep, your stress levels, your nutrition, and your emotional
             well-being. I am passionate about integrating modern medicine with timeless wellness practices
             like breathwork and mindfulness. My approach is to build a comprehensive wellness plan for
             you, not just a medical one.
           </p>
   
           <h3 style={{ marginTop: "32px" }}>Why I Chose Myprega:</h3>
           <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
             Myprega is the first platform I've seen that truly gets it. Their
             tech-enabled, continuous care model allows us to look at the whole picture of a mother's health,
             every single day. The brand's philosophy of treating the mother as a whole person, not a
             collection of symptoms, is the future of obstetrics.
           </p>
   
           <h3 style={{ marginTop: "32px" }}>Beyond the Clinic:</h3>
           <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
             I am a certified yoga instructor and practice every morning. I believe
             movement is medicine. On weekends, I love exploring local farmers' markets for fresh
             ingredients to experiment with new, healthy recipes. My favourite author is Thich Nhat Hanh.
           </p>
         </div>
          <div style={{ backgroundColor: "#f9f7f2", padding: "40px 20px" }}>
            <div
            className="doctor-intro-container"
              style={{
                maxWidth: "1100px",
                margin: "auto",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "24px",
                paddingTop: "32px",
              }}
            >
              {/* Favourite Book */}
              <div style={{ flex: 1, minWidth: "250px" }}>
                <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  📖 Favourite Book
                </p>
                <p style={{ color: "#333" }}>
                  Sapiens - A Brief History of Humankind
                </p>
              </div>
          
              {/* Divider */}
              <div
                className="vertical-divider"
                style={{
                  width: "1px",
                  backgroundColor: "#ccc",
                  height: "auto",
                  minHeight: "50px",
                  alignSelf: "stretch",
                  display: "none",
                }}
              ></div>
          
              {/* Favourite Singer */}
              <div style={{ flex: 1, minWidth: "250px" }}>
                <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  🎵 Favourite Singer
                </p>
                <p style={{ color: "#333" }}>Lata Mangeshkar</p>
              </div>
          
              {/* Divider */}
              <div
                className="vertical-divider"
                style={{
                  width: "1px",
                  backgroundColor: "#ccc",
                  height: "auto",
                  minHeight: "50px",
                  alignSelf: "stretch",
                  display: "none",
                }}
              ></div>
          
              {/* Favourite Pastime */}
              <div style={{ flex: 1, minWidth: "250px" }}>
                <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  🍽️ Favourite Pastime
                </p>
                <p style={{ color: "#333" }}>
                  Semi-classical music, <br />
                  Gardening
                </p>
              </div>
            </div>
          </div>
      <Footer />
    </>
  );
};

export default DrChayyaPalancontent;
